import React from 'react';

const FormContainer = ({ children, wide = false }) => {
  return (
    <div className={wide ? 'checkout-shell' : 'auth-panel'}>{children}</div>
  );
};

export default FormContainer;
